import companyFrag from "./Company";
import ConsignmentChannel from "./ConsignmentChannel";
import ConsignmentStatus from "./ConsignmentStatus";
import ConsignmentType from "./ConsignmentType";
import Currency from "./Currency";
import contactFrag from "./Contact";
import exhibitionFrag from "./Exhibition";
import consignmentFrag from "./ConsignmentWork";
import Entity from "./Entity";

const Consignment = (props = {}) => {
  // Handle case where props is true (include defaults) vs object (use configured fields)
  const includeDefaults = props === true || Object.keys(props).length === 0;
  const propsObj = typeof props === "object" && props !== null ? props : {};

  const {
    // Associations
    channel = false,
    company = false,
    consigner = false,
    consignmentWorks = false,
    contact = false,
    currency = false,
    exhibition = false,
    registrar = false,
    salesUser = false,
    status = false,
    type = false,
    // Scalar fields
    artistUserId = includeDefaults,
    channelId = includeDefaults,
    companyId = includeDefaults,
    colAddress = includeDefaults,
    colAddress2 = includeDefaults,
    colAddress3 = includeDefaults,
    colCompany = includeDefaults,
    colContactId = includeDefaults,
    colCounty = includeDefaults,
    colCountryId = includeDefaults,
    colName = includeDefaults,
    colPostcode = includeDefaults,
    colTown = includeDefaults,
    consigneeCompany = includeDefaults,
    consigneeEmail = includeDefaults,
    consigneeFax = includeDefaults,
    consigneeName = includeDefaults,
    consignerId = includeDefaults,
    consigneeTel = includeDefaults,
    contactId = includeDefaults,
    credit = includeDefaults,
    currencyId = includeDefaults,
    date = includeDefaults,
    due = includeDefaults,
    exchange = includeDefaults,
    exhibitionId = includeDefaults,
    guarantee = includeDefaults,
    notes = includeDefaults,
    noOfConsignmentWorks = includeDefaults,
    photoMaterial = includeDefaults,
    registrarId = includeDefaults,
    retAddress = includeDefaults,
    retAddress2 = includeDefaults,
    retAddress3 = includeDefaults,
    retCompany = includeDefaults,
    retContactId = includeDefaults,
    retCountryId = includeDefaults,
    retCounty = includeDefaults,
    retName = includeDefaults,
    retPostcode = includeDefaults,
    retTown = includeDefaults,
    salesUserId = includeDefaults,
    shipmentNotes = includeDefaults,
    statusId = includeDefaults,
    terms = includeDefaults,
    typeId = includeDefaults,
    updatedAt = includeDefaults,
  } = propsObj;

  return `
  id
  ${artistUserId ? "artistUserId" : ""}
  ${
    channel
      ? `channel {
      ${ConsignmentChannel}
    }`
      : ""
  }
  ${channelId ? "channelId" : ""}
  ${
    company
      ? `company {
      ${companyFrag({
        consignmentTerms: false,
        loanTerms: false,
        ...(typeof company === "object" ? company : {}),
      })}
    }`
      : ""
  }
  ${companyId ? "companyId" : ""}
  ${colAddress ? "colAddress" : ""}
  ${colAddress2 ? "colAddress2" : ""}
  ${colAddress3 ? "colAddress3" : ""}
  ${colCompany ? "colCompany" : ""}
  ${colContactId ? "colContactId" : ""}
  ${colCounty ? "colCounty" : ""}
  ${colCountryId ? "colCountryId" : ""}
  ${colName ? "colName" : ""}
  ${colPostcode ? "colPostcode" : ""}
  ${colTown ? "colTown" : ""}
  ${consigneeCompany ? "consigneeCompany" : ""}
  ${consigneeEmail ? "consigneeEmail" : ""}
  ${consigneeFax ? "consigneeFax" : ""}
  ${consigneeName ? "consigneeName" : ""}
  ${
    consigner
      ? `consigner {
      ${contactFrag(consigner)}
    }`
      : ""
  }
  ${consignerId ? "consignerId" : ""}
  ${consigneeTel ? "consigneeTel" : ""}
  ${
    contact
      ? `contact {
      ${contactFrag(contact)}
    }`
      : ""
  }
  ${contactId ? "contactId" : ""}
  ${
    consignmentWorks
      ? `consignmentWorks {
      ${consignmentFrag(consignmentWorks)}
    }`
      : ""
  }
  ${credit ? "credit" : ""}
  ${
    currency
      ? `currency {
      ${Currency}
    }`
      : ""
  }
  ${currencyId ? "currencyId" : ""}
  ${date ? "date" : ""}
  ${due ? "due" : ""}
  ${exchange ? "exchange" : ""}
  ${
    exhibition
      ? `exhibition {
      ${exhibitionFrag(exhibition)}
    }`
      : ""
  }
  ${exhibitionId ? "exhibitionId" : ""}
  ${guarantee ? "guarantee" : ""}
  ${notes ? "notes" : ""}
  ${noOfConsignmentWorks ? "noOfConsignmentWorks" : ""}
  ${photoMaterial ? "photoMaterial" : ""}
  ${registrarId ? "registrarId" : ""}
  ${
    registrar
      ? `registrar {
      ${Entity}
    }`
      : ""
  }
  ${retAddress ? "retAddress" : ""}
  ${retAddress2 ? "retAddress2" : ""}
  ${retAddress3 ? "retAddress3" : ""}
  ${retCompany ? "retCompany" : ""}
  ${retContactId ? "retContactId" : ""}
  ${retCountryId ? "retCountryId" : ""}
  ${retCounty ? "retCounty" : ""}
  ${retName ? "retName" : ""}
  ${retPostcode ? "retPostcode" : ""}
  ${retTown ? "retTown" : ""}
  ${salesUserId ? "salesUserId" : ""}
  ${
    salesUser
      ? `salesUser {
      ${Entity}
    }`
      : ""
  }
  ${shipmentNotes ? "shipmentNotes" : ""}
  ${
    status
      ? `status {
      ${ConsignmentStatus}
    }`
      : ""
  }
  ${statusId ? "statusId" : ""}
  ${terms ? "terms" : ""}
  ${
    type
      ? `type {
      ${ConsignmentType}
    }`
      : ""
  }
  ${typeId ? "typeId" : ""}
  ${updatedAt ? "updatedAt" : ""}
`;
};

export default Consignment;
